import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/header";
import Homepage from "./pages/Homepage";
import { DenominationProvider } from "./contexts/DenominationContext";
import Footer from "./components/Footer";
import About from "./pages/About";
import AffiliateDisclosure from "./pages/AffiliateDisclosure";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import GDPR from "./pages/GDPR";
import Contact from "./pages/Contact";
import Sitemap from "./pages/Sitemap";
import ScrollToTop from "./components/ScrollToTop";
import { Helmet } from "react-helmet-async";
import { JsonLdWebsite, JsonLdOrganization } from "./components/SEO/JsonLd";

function App() {
  return (
    <DenominationProvider>
      <Router>
        <ScrollToTop />
        {/* Google Analytics */}
        <Helmet>
          <script
            async
            src="https://www.googletagmanager.com/gtag/js?id=G-ZY7HJCK58S"
          ></script>
          <script>
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'G-ZY7HJCK58S');
            `}
          </script>
        </Helmet>

        {/* Global Schema.org structured data */}
        <JsonLdWebsite
          url="https://lo-fee.com"
          name="Lo-Fee.com - Canadian Bitcoin Exchange Fee Comparison"
          description="Compare Bitcoin exchange fees across major Canadian cryptocurrency platforms. Find the lowest trading fees, best rates, and payment methods."
        />
        <JsonLdOrganization
          name="Lo-Fee.com"
          url="https://lo-fee.com"
          sameAs={[
            "https://twitter.com/lofeedotcom",
            "https://facebook.com/lofeedotcom",
          ]}
        />

        <div className="min-h-screen bg-white flex flex-col">
          <Header />

          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/about" element={<About />} />
            <Route
              path="/affiliate-disclosure"
              element={<AffiliateDisclosure />}
            />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/gdpr" element={<GDPR />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/sitemap" element={<Sitemap />} />
          </Routes>

          <Footer />
        </div>
      </Router>
    </DenominationProvider>
  );
}

export default App;
